import { motion } from "framer-motion";
import { CHAPTERS, ABOUT_IMAGE } from "../data";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Manifesto() {
  return (
    <section id="about" className="bg-pearl py-24 md:py-36" data-testid="about">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-[11px] tracking-[0.35em] uppercase text-muted mb-16"
        >
          Über — In Drei Kapiteln
        </motion.p>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-7 space-y-16">
            {CHAPTERS.map((c, i) => (
              <motion.div
                key={c.no}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
                className="border-t border-line pt-6 flex gap-6 md:gap-10"
                data-testid={`chapter-${c.no}`}
              >
                <span className="font-serif text-2xl md:text-3xl text-muted shrink-0">{c.no}</span>
                <div>
                  <h3 className="font-serif italic font-light text-3xl md:text-4xl mb-4 text-charcoal">
                    {c.title}
                  </h3>
                  <p className="text-base md:text-lg leading-relaxed text-stone max-w-xl">
                    {c.body}
                  </p>
                </div>
              </motion.div>
            ))}

            {/* Model Profile / Steckbrief */}
            <motion.div
              custom={CHAPTERS.length}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className="border-t border-line pt-6 flex gap-6 md:gap-10"
              data-testid="about-details"
            >
              <span className="font-serif text-2xl md:text-3xl text-muted shrink-0">—</span>
              <div className="w-full">
                <h3 className="font-serif italic font-light text-3xl md:text-4xl mb-6 text-charcoal">
                  Steckbrief
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-y-8 gap-x-6 max-w-xl">
                  <div>
                    <span className="text-xs md:text-sm tracking-[0.12em] uppercase font-bold text-charcoal block mb-1.5">Augenfarbe</span>
                    <span className="text-lg md:text-xl text-charcoal font-serif font-bold italic">Grün</span>
                  </div>
                  <div>
                    <span className="text-xs md:text-sm tracking-[0.12em] uppercase font-bold text-charcoal block mb-1.5">Alter</span>
                    <span className="text-lg md:text-xl text-charcoal font-serif font-bold italic">11 Jahre</span>
                  </div>
                  <div>
                    <span className="text-xs md:text-sm tracking-[0.12em] uppercase font-bold text-charcoal block mb-1.5">Größe</span>
                    <span className="text-lg md:text-xl text-charcoal font-serif font-bold italic">155 cm</span>
                  </div>
                  <div>
                    <span className="text-xs md:text-sm tracking-[0.12em] uppercase font-bold text-charcoal block mb-1.5">Konfektionsgröße</span>
                    <span className="text-lg md:text-xl text-charcoal font-serif font-bold italic">32</span>
                  </div>
                  <div>
                    <span className="text-xs md:text-sm tracking-[0.12em] uppercase font-bold text-charcoal block mb-1.5">Staatsangehörigkeit</span>
                    <span className="text-lg md:text-xl text-charcoal font-serif font-bold italic">Deutsch</span>
                  </div>
                  <div>
                    <span className="text-xs md:text-sm tracking-[0.12em] uppercase font-bold text-charcoal block mb-1.5">Fremdsprache</span>
                    <span className="text-lg md:text-xl text-charcoal font-serif font-bold italic">Englisch</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <motion.div
              initial={{ clipPath: "inset(0 0 100% 0)" }}
              whileInView={{ clipPath: "inset(0 0 0% 0)" }}
              viewport={{ once: true }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
              className="overflow-hidden"
            >
              <img
                src="/img/uber.png"
                alt="Portrait of Janna"
                className="w-full h-[60vh] object-cover"
                data-testid="about-image"
              />
            </motion.div>
            <p className="mt-4 text-xs tracking-[0.2em] uppercase text-muted">
              Studio, Natürliches Licht
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
